import React from 'react';

export const DocumentsContext = React.createContext();

export const initialState = {
  ConteoSociodemografico: {},
  Conteo_GrupoEdad: {},
  Conteo_Rango_Ingreso: {},
  Conteo_Sexo: {},
  Conteo_Region: {},
  SentimientoProm_EdadIngreso: {},
  SentimientoProm_EdadRegion: {},
  SentimientoProm_GrupoEdad: {},
  SentimientoProm_Rango_Ingreso: {},
  SentimientoProm_Region: {},
  SentimientoProm_RegionIngreso: {},
  SentimientoProm_Semaforo: {},
  SentimientoProm_Sexo: {},
  SentimientoProm_SexoEdad: {},
  SentimientoProm_SexoIngreso: {},
  SentimientoProm_SexoRegion: {},
  SentimientoPromedioDiario: {},
  TrendGeneral: {},
  TrendSemaforo: {},
  Trend_EdadIngreso: {},
  Trend_EdadRegion: {},
  Trend_GrupoEdad: {},
  Trend_Rango_Ingreso: {},
  Trend_Region: {},
  Trend_RegionIngreso: {},
  Trend_Sexo: {},
  Trend_SexoEdad: {},
  Trend_SexoIngreso: {},
  Trend_SexoRegion: {},
  jsonFile: {}
};

export const reducer = (state, action) => {
  switch(action.type) {
    case "UPLOAD_DOCUMENT":
      let document = action.payload;
      let newReport = {[document.name]: document.data}
      return{
        ...state,
        // [document.name]: action.payload.data
        ...newReport
      }
    case "UPLOAD_DOCUMENT_SUCCESS":
      let { data } = action.payload
      return {
        ...state,
        data
      }
    case "UPLOAD_DOCUMENT_FAIL":
      let { error } = action.payload
      return {
        ...state,
        error
      };
    default: 
      return state
  }
};

// export function uploadDocumentRequest({ file, name }) {  
//   let data = new FormData();
//   data.append('file', document);
//   data.append('name', name);

//   return (dispatch) => {
//     axios.post('/files', data)
//       .then(response => dispatch(uploadSuccess(response))
//       .catch(error => dispatch(uploadFail(error));
//   };
// }

// /*
//  ... A lot of Redux / React boilerplate happens here 
//  like mapDispatchToProps and mapStateToProps and @connect ...
// */

// // Component method
// handleFileUpload({ file }) {
//   const file = files[0];
//   this.props.actions.uploadRequest({
//      file,
//      name: 'Awesome Cat Pic'
//   })
// }
  
// // Component render
// <input type="file" onChange={this.handleFileUpload} />